import 'bootstrap/dist/css/bootstrap.min.css';
import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router';
import * as Sentry from '@sentry/react';

import * as PermissionsHelper from '../helpers/permissionsHelper';

import styles from './appLayout.module.scss';
import { ClientsPage } from './clients/clientsPage';
import { ClientsUsersPageContainer } from './clients/users/clients-users-page';
import { baseMapDispatchToProps, baseMapStateToProps, ComponentBase } from './componentBase';
import EventPage from './events/eventPage';
import { MoEventsRoutes } from './moEvents/MoEventsRoutes';
import { EventsPage } from './events/eventsPage';
import { EventsPageLiveAndHybrid } from './events/eventsPageLiveAndHybrid';
import { EventsPageQaQueue } from './events/eventsPageQaQueue';
import TopMenu from './navigation/topMenu';
import { PageNotFound } from './pages/pageNotFound';
import LoggedOutPage from './session/loggedOutPage';
import ChangeMyPassword from './users/changeMyPassword';
import ChangeOtherUsersPassword from './users/changeOtherUsersPassword';
import { UsersPage } from './users/usersPage';
import { ClientsClipTemplateMappingPage } from './clients/clip-template-mapper/clip-template-mapper-page';
import { NotificationsPage } from './notifications/notificationsPage';
import { MonitoringVGContainer } from './monitoring/virtualGraduationMonitoring/MonitoringVGContainer';
import { QaQueue } from './qaQueue/QaQueue';
import { ParticipantSearchContainer } from './participantSearch/ParticipantSearchContainer';
import { MailerLogTableContainer } from './mailerLog/MailerLogTableContainer';
import { PortalsPageContainer } from './portals/PortalsPageContainer';
import { ShopsPage } from './shops/shopsPage';
import { MonitoringContainer } from './monitoring/eventsMonitoring/MonitoringContainer';
import { ClipGeneratorPageContainer } from './clipGeneratorV2/ClipGeneratorPageContainer';

class AppLayout extends ComponentBase<RouteComponentProps<any>> {
  protected loggedInRender() {
    return (
      <div className={styles.stageClipApp}>
        <TopMenu />
        <div className={styles.appContainerWrapper}>
          <div className={styles.appContainer}>
            <Switch>
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessClientsPage) && (
                <Route path="/clients" component={ClientsPage} exact />
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.UpdateClipTemplateConfiguration) && (
                <Route path="/clients/:id/clip-template-mapper" component={ClientsClipTemplateMappingPage} />
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessClientsUsersPage) && (
                <Route path="/clients/:id" component={ClientsUsersPageContainer} />
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessShops) && (
                <Route path="/shops" component={ShopsPage} />
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessPortals) && (
                <Route path="/clip-sites" component={PortalsPageContainer} />
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.MonitoringPage) && (
                <Route path="/monitoring" component={MonitoringContainer} />
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.MonitoringVGPage) && (
                <Route path="/monitoring-vg" component={MonitoringVGContainer} />
              )}
              <Route path="/users/change-my-password" component={ChangeMyPassword} />
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.ChangeOtherUsersPassword) && (
                <Route path="/users/:userId/change-password" component={ChangeOtherUsersPassword} />
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessUsersPage) && (
                <Route path="/users" component={UsersPage} />
              )}
              <Route path="/events/:eventId" component={EventPage} />
              <Route path="/events" component={EventsPage} />
              <Route path="/events-clipping-queue" component={EventsPageLiveAndHybrid} />
              <Route path="/events-qa-queue" component={EventsPageQaQueue} />
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessClipGenerator) && (
                <Route path="/clip-generator" component={ClipGeneratorPageContainer} />
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.GetMoEvents) && (
                <Route path="/mo-events" component={MoEventsRoutes} />
              )}
              <Route path="/notifications" component={NotificationsPage} />
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.VgQaQueue) && (
                <Route path="/qa-queue" component={QaQueue} />
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AccessAdminSection) && (
                <Route path="/participant-search" component={ParticipantSearchContainer} />
              )}
              {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.ViewMailerLog) && (
                <Route path="/mailer-log" component={MailerLogTableContainer} />
              )}
              <Route path="/" component={EventsPage} exact />
              <Route path="/" component={PageNotFound} />
            </Switch>
          </div>
        </div>
      </div>
    );
  }

  protected loggedOutRender() {
    return (
      <div className={styles.stageClipApp}>
        <TopMenu />
        <LoggedOutPage />
      </div>
    );
  }
}

export default Sentry.withProfiler(withRouter(connect(baseMapStateToProps, baseMapDispatchToProps)(AppLayout)), {
  includeRender: true,
  includeUpdates: true,
});
